export const AusDerRegionTheme = {
  name: 'Aus der Region Theme',
  themeId: 'ausDerRegion',
  colors: {
    brand: {
      primary: {
        100: '#007ab2'
      },
      secondary: {
        100: '#004181'
      },
      highlight: {
        100: '#004181'
      }
    },
    tints: {
      gray: {
        10: '#f1f1f1',
        25: '#e5e5e5',
        40: '#b2b2b2',
        45: '#969696',
        60: '#666666',
        75: '#4d4d4d',
        90: '#333333',
        100: '#000000'
      },
      white: {
        100: '#FFFFFF'
      }
    }
  },
  fonts: {
    families: {
      text: '"Helvetica Now Display", "Helvetica", arial, sans-serif'
    },
    sizes: {
      text: {
        xsmall: '15px',
        small: '17px',
        huge: '98px'
      },
      heading: {
        xsmall: '20px',
        small: '20px'
      }
    }
  },
  backgrounds: {
    tile: '#5B8FCB'
  },
  spacings: {
    medium: '13px'
  }
};